import React from 'react';

function Disclaimer() {
    return (
        <div className="disclaimer">
            <strong>Can't find a part you're looking for?</strong> 
            <br />
            Please contact customer service for assistance at{' '}
            <a href="mailto:support@chalmersgroup.com">support@chalmersgroup.com</a>
            {' '}or call{' '}
            <a href="tel:+19053626400">(905)-362-6400</a>
        </div>
    );
}

export default Disclaimer;
